import { stringifyCsv } from '@neo.tax/shared';

const HEADERS = ['project_name', 'project_description'];

export const HEADERS_STRINGIFIED = stringifyCsv([HEADERS]);

export const EXAMPLE_DATA_STRINGIFIED = stringifyCsv([
  HEADERS,
  [
    'Real-Time Fraud Detection Engine',
    'Developed a streaming ML pipeline to score transactions for fraud in under 50ms. Experimented with gradient-boosted trees versus a custom neural model to resolve latency-versus-accuracy uncertainty.',
  ],
  [
    'Multi-Tenant Data Isolation Layer',
    'Prototyped a row-level security architecture to guarantee tenant data isolation in a shared Postgres cluster. Evaluated multiple partitioning strategies to overcome unknown performance impacts at scale.',
  ],
  [
    'Adaptive Video Bitrate Algorithm',
    'Built an adaptive bitrate streaming algorithm that adjusts encoding to fluctuating network conditions. Iterated on buffering heuristics to maintain playback quality on unreliable mobile connections.',
  ],
]);
